export * from './IconPolygonMultiple';
